// extracted by mini-css-extract-plugin
export default {"main-content":"Forms_main-content__RqFZ7","tab-content":"Forms_tab-content__5yYWk","buttons":"Forms_buttons__si+KQ"};